<!-- eslint-disable max-len -->
<template>
  <div
    :class="{
      'opacity-0 pointer-events-none': !notification.show,
      'modal-active': notification.show
    }"
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center overflow-y-auto notification_model_block"
  >
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>
    <div class="modal-container bg-white w-full shadow-lg z-50  rounded-t-xl">
      <div class="modal-content py-4 text-left px-4">
        <div class="notify-block block text-center ">
          <div
            v-if="notification.icon.show"
            class="flex align-center justify-center icon-block mb-6-5"
          >
            <svg
              v-if="notification.icon.type === 'dollar'"
              width="50"
              height="48"
              viewBox="0 0 51 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.166992 49.1875V20.125H50.542V49.1875H0.166992ZM7.91699 45.3125H42.792C42.792 43.1707 44.5251 41.4375 46.667 41.4375V27.875C44.5251 27.875 42.792 26.1418 42.792 24H7.91699C7.91699 26.1418 6.18384 27.875 4.04199 27.875V41.4375C6.18384 41.4375 7.91699 43.1707 7.91699 45.3125ZM25.3545 43.375C21.0708 43.375 17.6045 39.4697 17.6045 34.6562C17.6045 29.8428 21.0708 25.9375 25.3545 25.9375C29.6382 25.9375 33.1045 29.8428 33.1045 34.6562C33.1045 39.4697 29.6382 43.375 25.3545 43.375ZM25.3545 39.5C27.4888 39.5 29.2295 37.3279 29.2295 34.6562C29.2295 31.9846 27.4888 29.8125 25.3545 29.8125C23.2202 29.8125 21.4795 31.9846 21.4795 34.6562C21.4795 37.3279 23.2202 39.5 25.3545 39.5ZM10.8232 37.5625C9.21875 37.5625 7.91699 36.2607 7.91699 34.6562C7.91699 33.0518 9.21875 31.75 10.8232 31.75C12.4277 31.75 13.7295 33.0518 13.7295 34.6562C13.7295 36.2607 12.4277 37.5625 10.8232 37.5625ZM39.8857 37.5625C38.2812 37.5625 36.9795 36.2607 36.9795 34.6562C36.9795 33.0518 38.2812 31.75 39.8857 31.75C41.4902 31.75 42.792 33.0518 42.792 34.6562C42.792 36.2607 41.4902 37.5625 39.8857 37.5625ZM23.417 16.25V10.4375H15.667L25.3545 0.75L35.042 10.4375H27.292V16.25H23.417Z"
                fill="#63B15B"
              />
            </svg>
            <svg
              v-else-if="notification.icon.type === 'success'"
              class="w-14 h-14"
              viewBox="0 0 52 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.0001 0.166992C11.7557 0.166992 0.166748 11.7559 0.166748 26.0003C0.166748 40.2447 11.7557 51.8337 26.0001 51.8337C40.2445 51.8337 51.8334 40.2447 51.8334 26.0003C51.8334 11.7559 40.2445 0.166992 26.0001 0.166992ZM26.0001 4.04199C38.1503 4.04199 47.9584 13.8501 47.9584 26.0003C47.9584 38.1505 38.1503 47.9587 26.0001 47.9587C13.8499 47.9587 4.04175 38.1505 4.04175 26.0003C4.04175 13.8501 13.8499 4.04199 26.0001 4.04199ZM35.6497 18.2327C35.1466 18.2473 34.6688 18.4572 34.3177 18.818L22.7709 30.3647L17.6825 25.2763C17.5039 25.0903 17.2901 24.9419 17.0535 24.8396C16.8168 24.7374 16.5622 24.6833 16.3044 24.6807C16.0467 24.6781 15.791 24.7269 15.5523 24.8244C15.3137 24.9218 15.0968 25.0659 14.9146 25.2481C14.7323 25.4304 14.5882 25.6472 14.4908 25.8859C14.3934 26.1245 14.3445 26.3802 14.3471 26.638C14.3498 26.8958 14.4038 27.1504 14.506 27.387C14.6083 27.6237 14.7568 27.8375 14.9427 28.016L21.401 34.4744C21.7644 34.8376 22.2571 35.0416 22.7709 35.0416C23.2847 35.0416 23.7774 34.8376 24.1408 34.4744L37.0575 21.5577C37.337 21.2855 37.5278 20.9352 37.605 20.5527C37.6821 20.1703 37.642 19.7734 37.4899 19.4141C37.3378 19.0548 37.0807 18.7498 36.7524 18.539C36.4241 18.3282 36.0398 18.2214 35.6497 18.2327Z"
                fill="#63B15B"
              />
            </svg>
          </div>
          <h4 class="block text-center text-smm text-darkgray font-bold">
            {{ notification.heading }}
          </h4>
          <p class="block text-center text-xss text-darkgray1 font-normal mb-5	">
            {{ notification.desc }}
          </p>
          <div
            v-if="notification.buttons.okay.text"
            class="flex justify-end  filter_action_block"
          >
            <button
              class="flex items-center justify-center btn_apply rounded-lg text-white btn_action"
              @click="btnAction('okay')"
            >
              {{ notification.buttons.okay.text }}
            </button>
          </div>
          <div
            v-if="notification.buttons.cancel.text"
            class="flex justify-end pt-2 filter_action_block"
          >
            <button
              class="relative flex items-center justify-center flex-nowrap text-darkgreen text-sm walter-footer pt-3 pb-3 pl-4 pr-4 border solid border-darkgreen rounded bg-transparent w-full text-center"
              @click="btnAction('cancel')"
            >
              {{ notification.buttons.cancel.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Notification",
  computed: {
    ...mapGetters("app", ["notification"])
  },
  methods: {
    btnAction(type) {
      if (typeof this.notification.buttons[type].action === "function") {
        this.notification.buttons[type].action();
      }
      this.$store.commit("app/hideNotification");
    }
  }
};
</script>

<style scoped>
.btn_apply {
  background-color: #63b15b !important;
  color: #fff !important;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 18px;
  letter-spacing: 0.5px;
  border: 1px solid #63b15b !important;
  outline: none !important;
  box-shadow: none !important;
}
.notification_model_block {
  padding: 10px 14px;
  z-index: 9999999999999999999;
}
.notification_model_block .modal-container {
  border-radius: 16px;
}

/* .notification_model_block .modal-container .notify-block {
  display: block;
  text-align: center;
} */

/* .notification_model_block .modal-container .notify-block .icon-block {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .notification_model_block .modal-container .notify-block h4 {
  font-size: 17px;
  font-weight: 600;
  margin: 12px 0 4px;
  display: block;
  width: 100%;
}

.notification_model_block .modal-container .notify-block p {
  font-size: 13px;
  font-weight: 400;
} */

.notification_model_block .modal-container .btn_apply {
  width: 100%;
  margin: 10px 0 0;
  font-size: 14px !important;
}
</style>
